import React from "react";
import ancianos from "../../../assets/img/ancianos.jpg";

const LegadosBannerComponent = () => (
  <div className="row mb-4" id="legados-banner-container">
    <div className="col-12">
      <img
        src={ancianos}
        alt="Legados - Hospital Británico"
        className="w-100 b-radius-10"
        style={{
          height: 320,
          objectFit: "cover",
        }}
      />
    </div>
  </div>
);

export default LegadosBannerComponent;
